import React from 'react';
import './Footer.css';

const links = [
  { label: 'About',    href: '#about' },
  { label: 'Values',   href: '#mission' },
  { label: 'Services', href: '#services' },
  { label: 'SCRIP',    href: '#scrip' },
  { label: 'Contact',  href: '#contact' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <a href="#hero" className="footer-logo">
        <img src="/mark.PNG" alt="Grantsman mark" className="footer-mark" />
        <span>GRANTSMAN</span>
      </a>
      <nav className="footer-links">
        {links.map((l) => (
          <a key={l.label} href={l.href}>{l.label}</a>
        ))}
      </nav>
      <div className="footer-copy">
        © {new Date().getFullYear()} Grantsman. Intelligence. Security. Integrity.
      </div>
    </footer>
  );
}
